import { ActivityIndicator } from 'react-native';

import { tokens } from '../../tokens';

import type { ButtonSize, ButtonType } from './types';

type ButtonActivityIndicatorProps = {
  size: ButtonSize;
  type: ButtonType;
  disabled?: boolean;
};

const buttonSizeToIndicatorSize = {
  xs: 15,
  sm: 18,
  md: 21,
  lg: 24,
  xl: 24,
};

export function ButtonActivityIndicator(props: ButtonActivityIndicatorProps) {
  let color: string = tokens.colors.$houseRedDarken;
  if (props.disabled) {
    color = tokens.colors.$houseDark;
  }
  return <ActivityIndicator size={buttonSizeToIndicatorSize[props.size]} color={color} />;
}
